import ListOfEquipmentSubscriptionToggles from '@/pages/User/AccountSettingsSidePage/components/ListEquipmentSubscriptionsToggles'
import SeparateLine from '@/shared/Forms/SeparateLine'
import Button from '@/shared/Buttons/Button'
import useListEquipmentSubscriptionsCtrl from '@/pages/User/AccountSettingsSidePage/hooks/useListEquipmentSubscriptionsCtrl.ts'
import userApi from '@/pages/User/user.api.ts'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import useNotificationsChannelsCtrl from '@/pages/User/AccountSettingsSidePage/hooks/useNotificationsChannelsCtrl.ts'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import SettingsIcon from '@/assets/icons/settingsIcon.svg?react'
import { useState } from 'react'
import Image from '@/shared/Common/Image'
import qrCodeSrc from '@/assets/images/tg_qr.jpg'
import Skeleton from '@/shared/Loaders/Skeleton'

interface IProps {
  onClose: () => void
}

const NotificationsContent = (props: IProps) => {
  const { wait: waitSubmitFormRequest, loading: submitFormLoading } = useHttpLoader()

  const [configureTgFormOpen, setConfigureTgFormOpen] = useState(false)

  const equipmentSubsCtrl = useListEquipmentSubscriptionsCtrl()
  const notificationChannelsCtrl = useNotificationsChannelsCtrl()

  const handleSave = () => {
    const { sub, unsub } = equipmentSubsCtrl.equipmentSubscriptionsChangesRef.current
    const job = async () => {
      const unsubRequest = unsub.size > 0 ? userApi.unsubscribeFromEquipmentEventList([...unsub]) : null
      const subRequest = sub.size > 0 ? userApi.subscribeToEquipmentEventList([...sub]) : null

      const [unsubResp, subResp] = await Promise.all([unsubRequest, subRequest])
      return { unsubResp, subResp }
    }

    waitSubmitFormRequest(job(), () => {})
  }

  if (configureTgFormOpen) {
    return (
      <div className="flex-lines gap16 height100">
        <div className="flex-lines gap16" style={{ paddingRight: '24px' }}>
          <h5 className="text-heading-5">Настройка Telegram уведомлений</h5>
        </div>
        <p className="text-nm">
          Отсканируйте QR-Код, либо перейдите по <a href="https://t.me/intertech_ntf_bot">ссылке</a> и нажмите "Start".
          Бот отправит вам сообщение, в котором укажет Chat ID, значение вида "908988285". Скопируйте значение и
          вставьте в поле ниже.
        </p>
        <FormField label="Chat ID">
          <TextInput
            value={notificationChannelsCtrl.data.telegramChartID}
            name="telegramChartID"
            onChange={notificationChannelsCtrl.handlers.setTelegramChartID}
            placeHolder="000000000"
          />
        </FormField>
        <div className="flex-lines center width100" style={{ alignItems: 'center' }}>
          <Image
            src={qrCodeSrc}
            alt="QR Код"
            style={{ width: '50%' }}
            wrapperStyle={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          />
        </div>
        <div className="inline-flex-gap gap8" style={{ marginTop: 'auto' }}>
          <Button
            size="default"
            type="primary"
            text="Сохранить"
            loading={submitFormLoading}
            disabled={!notificationChannelsCtrl.data.telegramChartID.length}
            onClick={handleSave}
          />
          <Button
            size="default"
            type="default"
            text="Назад"
            onClick={() => setConfigureTgFormOpen(false)}
            disabled={submitFormLoading}
          />
        </div>
      </div>
    )
  }
  return (
    <div className="flex-lines gap16 height100">
      <div className="flex-lines gap16" style={{ paddingRight: '24px' }}>
        <h5 className="text-heading-5">Каналы уведомлений</h5>
        <FormField
          label="Telegram"
          labelTooltipTextPosition="right"
          labelTooltipText={`Телеграмм-бот будет отправлять вам уведомления об ошибках лифтов, скорой просрочке ТО по лифтам, за которые вы ответственны, а также о факте просрочки ТО.`}
        >
          <Skeleton height="32px" width="100%" loading={notificationChannelsCtrl.data.dataLoading}>
            <div className="inline-flex-gap gap16 center">
              {notificationChannelsCtrl.data.telegramChannel && (
                <p className="text-nm">Chat ID: {notificationChannelsCtrl.data.telegramChannel.telegramChatId}</p>
              )}
              <Button
                size="default"
                type="default"
                text="Настроить"
                icon={<SettingsIcon />}
                onClick={() => setConfigureTgFormOpen(true)}
              />
            </div>
          </Skeleton>
        </FormField>
        <FormField
          label="Адрес электронной почты (Email)"
          labelTooltipText={`На указанный адрес вы будете получать уведомления об ошибках лифтов, скорой просрочке ТО по лифтам, за которые вы ответственны, а также о факте просрочки ТО.`}
        >
          <Skeleton height="32px" width="100%" loading={notificationChannelsCtrl.data.dataLoading}>
            <TextInput
              value={notificationChannelsCtrl.data.emailAddress}
              name="emailAddress"
              onChange={notificationChannelsCtrl.handlers.setEmailAddress}
              placeHolder="example@intertechnologies.ru"
            />
          </Skeleton>
        </FormField>
      </div>
      <SeparateLine />
      <ListOfEquipmentSubscriptionToggles
        currentEquipmentSubscriptions={equipmentSubsCtrl.currentEquipmentSubscriptions}
        onChange={equipmentSubsCtrl.onSubscriptionChange}
        handleUnsubscribeAll={equipmentSubsCtrl.handleUnsubscribeAll}
        handleSubscribeAll={equipmentSubsCtrl.handleSubscribeAll}
        loading={equipmentSubsCtrl.equipmentSubscriptionsListLoading}
        equipmentSubscriptionsChanges={equipmentSubsCtrl.equipmentSubscriptionsChangesRef}
      />
      <div style={{ paddingRight: '24px' }} className="flex-lines gap16">
        <SeparateLine />
        <div className="inline-flex-gap gap8">
          <Button
            size="default"
            type="primary"
            text="Сохранить"
            loading={submitFormLoading}
            disabled={!equipmentSubsCtrl.isEquipmentSubscriptionsHaveChanges()}
            onClick={handleSave}
          />
          <Button size="default" type="default" text="Отменить" onClick={props.onClose} disabled={submitFormLoading} />
        </div>
      </div>
    </div>
  )
}

export default NotificationsContent
